import Vue from "vue";
// 引入路由
import VueRouter from "vue-router";
import { Message } from "element-ui";
import { hasPerm, isPlatformUser, permState, loadPermInfo } from "@/utils/permission";
import { USE_ROUTE_GUARD } from "@/config";

Vue.use(VueRouter);

/**
 * 路由 → 权限码 映射（RBAC）
 * '__platform__' 表示平台专有页，走 $isPlatformUser() 而非权限码
 * 设计文档：docs/RBAC前端权限显示设计.md §3.4
 */
const ROUTE_PERM = {
  "/realTimeData": "data:realtime:view",
  "/history": "data:history:view",
  "/laboratory": "lab:order:view",
  "/system": "point:view",        // 系统管理是容器页，用最低门槛进门
  "/loginStatus": null,           // 账户状态页，不做限制
  "/myPage": "__platform__",
  "/screen": "data:screen:view",
  "/ops": "ops:check:template:view", // 智能运维是容器页，用最低门槛进门
};

// 创建路由器
const router = new VueRouter({
  // mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "/login",
      component: () => import("@/views/login/index.vue"),
      name: "Login",
    },
    // 可视化大屏
    {
      path: "/screen",
      name: "Screen",
      component: () => import("@/views/screen/index.vue"),
      meta: {
        title: "可视化大屏",
        hidden: false,
        icon: "",
      },
    },
    // 主页内容
    {
      path: "/home",
      component: () => import("@/views/home/index.vue"),
      name: "Home",
      meta: {
        title: "主页", // 菜单标题
        hidden: false,
        icon: "",
      },
      redirect: "/realTimeData",
      children: [
        {
          path: "/realTimeData",
          component: () => import("@/views/realTimeData/index.vue"),
          name: "realTimeData",
          // meta: {
          //   title: "statusPage",
          // },
          // meta: {
          //   title: "实时数据", // 菜单标题
          //   hidden: false,
          //   icon: "",
          // },
        },
        {
          path: "/history",
          component: () => import("@/views/history/index.vue"),
          name: "history",
        },
        {
          path: "/laboratory",
          component: () => import("@/views/laboratory/index.vue"),
          name: "laboratory",
        },
        {
          path: "/system",
          component: () => import("@/views/system/index.vue"),
          name: "system",
        },

        // 智能运维（运维管理四线：巡检/任务/工单/仓储）
        {
          path: "/ops",
          component: () => import("@/views/ops/index.vue"),
          name: "ops",
        },

        // 账户状态
        {
          path: "/loginStatus",
          component: () => import("@/views/loginStatus/index.vue"),
          name: "loginStatus",
        },

        // 我的
        {
          path: "/myPage",
          component: () => import("@/views/myPage/index.vue"),
          name: "myPage",
        },
      ],
    },
  ],
});

/**
 * 路由守卫（RBAC）
 * ⚠️ 权限未加载时 hasPerm / isPlatformUser 一律返回 true → 放行，绝不锁死导航
 */
router.beforeEach((to, from, next) => {
  if (to.path === "/" || to.path === "/login") {
    return next();
  }

  const token = localStorage.getItem("token");
  if (!token) {
    return next("/login");
  }

  if (!USE_ROUTE_GUARD) {
    return next();
  }

  // 有 token 但权限还没拉到 → 触发一次加载（异步，不阻塞本次导航）
  if (!permState().loaded) {
    loadPermInfo();
  }

  const need = ROUTE_PERM[to.path];
  if (!need) {
    return next();
  }

  let ok;
  if (need === "__platform__") {
    ok = isPlatformUser();
  } else {
    ok = hasPerm(need);
  }

  if (!ok) {
    Message.error("该用户暂无查看权限!");
    return next(false);
  }
  next();
});

export default router;
